import { render, staticRenderFns } from "./pwdMod.vue?vue&type=template&id=30f1e97b&scoped=true&"
import script from "./pwdMod.vue?vue&type=script&lang=js&"
export * from "./pwdMod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f1e97b",
  null
  
)

export default component.exports